import {createSlice} from '@reduxjs/toolkit'
import {Report} from "src/types/generated";

const slice = createSlice({
    name: 'report',
    initialState: {
        data: [] as Report[]
    },
    reducers: {
        readedAll: (state, action) => {
            state.data = action.payload;
        },
        created: (state, action) => {
            state.data.push(action.payload);
        },
    },
})

export const actions = slice.actions;
export default slice.reducer;
